import React from 'react';
import { Star } from 'lucide-react';
interface RatingProps {
  value: number;
  count?: number;
  showCount?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function Rating({
  value,
  count,
  showCount = true,
  size = 'sm',
  className = ''
}: RatingProps) {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };
  const iconSize = sizes[size];
  const fullStars = Math.floor(value);
  const hasHalfStar = value % 1 !== 0;
  return <div className={`flex items-center gap-1.5 ${className}`} data-id="element-17758">
      <div className="flex text-amber-400" data-id="element-17759">
        {[...Array(5)].map((_, i) => {
        if (i < fullStars) {
          return <Star key={i} className={`${iconSize} fill-current`} data-id="element-17760" />;
        }
        if (i === fullStars && hasHalfStar) {
          // Simple half star representation using CSS clip-path or just a filled star with opacity for simplicity in this mockup
          return <div key={i} className="relative" data-id="element-17761">
                <Star className={`${iconSize} text-slate-200 fill-current`} data-id="element-17762" />
                <div className="absolute inset-0 overflow-hidden w-1/2" data-id="element-17763">
                  <Star className={`${iconSize} text-amber-400 fill-current`} data-id="element-17764" />
                </div>
              </div>;
        }
        return <Star key={i} className={`${iconSize} text-slate-200 fill-current`} data-id="element-17765" />;
      })}
      </div>
      {showCount && count !== undefined && <span className="text-sm text-slate-500 ml-1" data-id="element-17766">
          {value.toFixed(1)} ({count})
        </span>}
    </div>;
}